import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      {/* Certification Section */}
      <div className={styles.footerCertification}>
        <span className={styles.certLabel}>CERTIFIED BY:</span>
        <div className={styles.certBadges}>
          <a
            href="https://www.legitscript.com/websites/ovalcare.com/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.certBadge}
          >
            <img
              src="/images/legit-script.webp"
              alt="LegitScript approved"
              className={styles.certBadgeImg}
            />
          </a>
          <img
            src="/images/hipaa-compliant.webp"
            alt="HIPAA Compliant"
            className={styles.hipaaBadgeImg}
          />
        </div>
      </div>

      {/* Legal Links */}
      <div className={styles.footerLinks}>
        <Link to="/terms">Terms & Conditions</Link>
        <span className={styles.linkDivider}>|</span>
        <Link to="/privacy">Privacy Policy</Link>
        <span className={styles.linkDivider}>|</span>
        <Link to="/hipaa">HIPAA Notice</Link>
        <span className={styles.linkDivider}>|</span>
        <Link to="/states">States We Serve</Link>
        <span className={styles.linkDivider}>|</span>
        <Link to="/returns">Returns & Refunds</Link>
        <span className={styles.linkDivider}>|</span>
        <a href="https://ovalcare.com/partners" target="_blank" rel="noopener noreferrer">Partners</a>
      </div>

      {/* Copyright */}
      <div className={styles.footerBottom}>
        <p>&copy; {new Date().getFullYear()} Oval Care Inc. All rights reserved.</p>
      </div>

      {/* Logo at very bottom */}
      <div className={styles.footerLogo}>
        <Link to="/">
          <img
            src="/oval-logo.webp"
            alt="Oval Care"
            className={styles.logoImg}
          />
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
